<button
  (click)="onSubscribe()"
  class="subscribe-button fz-button--small"
  [disabled]="loading"
  color="primary"
  mat-flat-button
  data-ga-value="subscribe-button"
  [ngClass]="{ responsive: responsive }"
>
  <mat-icon>notifications</mat-icon>
  {{ !eventSchedule?.subscriptionStatus ? 'Subscribe' : 'Subscribed' }}
</button>
